import { alertClasses, Components, linkClasses, Theme } from '@mui/material';

export const MuiAlert: Components<Theme>['MuiAlert'] = {
  defaultProps: {
    variant: 'standard',
    severity: 'success',
  },
  styleOverrides: {
    standardError: ({ theme }) => ({
      ...theme.typography.body1,
      backgroundColor: theme.palette.alert.error.background,
      color: theme.palette.alert.error.text,
      [`&	.${alertClasses.icon}`]: {
        color: theme.palette.alert.error.text,
      },
      borderRadius: theme.featureFlags.panwRebrandStubYear ? theme.shape.borderRadiusMd : undefined,
    }),
    standardInfo: ({ theme }) => ({
      ...theme.typography.body1,
      backgroundColor: theme.palette.alert.info.background,
      color: theme.palette.alert.info.text,
      [`&	.${alertClasses.icon}`]: {
        color: theme.palette.alert.info.text,
      },
      borderRadius: theme.featureFlags.panwRebrandStubYear ? theme.shape.borderRadiusMd : undefined,
    }),
    standardSuccess: ({ theme }) => ({
      ...theme.typography.body1,
      backgroundColor: theme.palette.alert.success.background,
      color: theme.palette.alert.success.text,
      [`&	.${alertClasses.icon}`]: {
        color: theme.palette.alert.success.text,
      },
      borderRadius: theme.featureFlags.panwRebrandStubYear ? theme.shape.borderRadiusMd : undefined,
    }),
    standardWarning: ({ theme }) => ({
      ...theme.typography.body1,
      backgroundColor: theme.palette.alert.warning.background,
      color: theme.palette.alert.warning.text,
      [`&	.${alertClasses.icon}`]: {
        color: theme.palette.alert.warning.text,
      },
      borderRadius: theme.featureFlags.panwRebrandStubYear ? theme.shape.borderRadiusMd : undefined,
    }),
    root: {
      ['& .' + linkClasses.root]: {
        textDecoration: 'underline',
      },
      alignItems: 'center',
    },
    action: {
      padding: 0,
    },
  },
};
